<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="info-user">
      <img
        v-if="img"
        :src="img"
        class="round-bordered-img-small">
      <div
        v-else
        class="img-responsive-home round-bordered-img-home"/>
    </div>
    <div class="label-home-1">Selamat Datang</div>
    <div class="label-home-2">{{ name }}</div>
    <div class="label-home-3">{{ nip }}</div>
    <div class="content-officeless-home">
      <div class="application-officeless-box">
        <div class="title-bold m__b--10">
          MODULE
        </div>
        <b-row class="application-row">
          <!-- <b-col
            cols="3"
            class="p__l--5 p__r--5 p__b--10"
            @click="chooseMenu('setting')">
            <div class="card border-0">
              <div class="card-body application-card">
                <img
                  src="../../assets/menu-home/admin.png"
                  class="icon-aplication m__r--10">
                <div class="text-aplication">
                  ADMIN
                </div>
              </div>
            </div>
          </b-col> -->
          <b-col
            v-if="isKurikulum"
            cols="3"
            class="p__l--5 p__r--5 p__b--10"
            @click="chooseMenu('kurikulum')">
            <div class="card border-0">
              <div class="card-body application-card">
                <img
                  src="../../assets/menu-home/kurikulum.png"
                  class="icon-aplication m__r--10">
                <div class="text-aplication">
                  KURIKULUM
                </div>
              </div>
            </div>
          </b-col>
          <b-col
            v-if="isKesiswaan"
            cols="3"
            class="p__l--5 p__r--5 p__b--10"
            @click="chooseMenu('kesiswaan')">
            <div class="card border-0">
              <div class="card-body application-card">
                <img
                  src="../../assets/menu-home/kesiswaan.png"
                  class="icon-aplication m__r--10">
                <div class="text-aplication">
                  KESISWAAN
                </div>
              </div>
            </div>
          </b-col>
          <b-col
            v-if="isBK"
            cols="3"
            class="p__l--5 p__r--5 p__b--10"
            @click="chooseMenu('bk')">
            <div class="card border-0">
              <div class="card-body application-card">
                <img
                  src="../../assets/menu-home/bk.png"
                  class="icon-aplication m__r--10">
                <div class="text-aplication">
                  BIMBINGAN KONSELING
                </div>
              </div>
            </div>
          </b-col>
          <b-col
            v-if="isHubin"
            cols="3"
            class="p__l--5 p__r--5 p__b--10"
            @click="chooseMenu('hubin')">
            <div class="card border-0">
              <div class="card-body application-card">
                <img
                  src="../../assets/menu-home/hubin.png"
                  class="icon-aplication m__r--10">
                <div class="text-aplication">
                  HUBUNGAN INDUSTRI
                </div>
              </div>
            </div>
          </b-col>
          <b-col
            cols="3"
            class="p__l--5 p__r--5 p__b--10"
            @click="directToSino()">
            <div class="card border-0">
              <div class="card-body application-card">
                <img
                  src="../../assets/menu-home/sino.png"
                  width="40"
                  class="icon-aplication m__r--10">
                <div class="text-aplication">
                  SINO
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div
        v-if="data_notif"
        v-show="data_notif.notif"
        class="notification-container">
        <b-row>
          <b-col md="10">
            {{ data_notif ? data_notif.message_notif : '' }}
          </b-col>
          <b-col md="2">
            <div
              class="btn-update-notif"
              @click="$refs.modalRiwayat.show()">
              Update Data
            </div>
          </b-col>
        </b-row>
      </div>

      <div
        v-for=" (item, index) in data_pengumuman"
        :key="index"
        class="application-officeless-box">
        <div class="title-bold">PENGUMUMAN</div>
        <b-row>
          <b-col md="6">
            <div class="label-date-pengumuman">
              <img
                src="../../assets/menu-home/calendar.png"
                class="m__r--10">
              {{ convertDate(item.start_date) }} - {{ convertDate(item.end_date) }}
            </div>
          </b-col>
          <b-col md="6">
            <div
              class="btn-detail-pengumuman"
              @click="openModalPengumuman(item)">
              Detail
            </div>
          </b-col>
        </b-row>

        <div class="container-pengumuman">
          <div class="text-pengumuman">{{ item.subject }}</div>
        </div>
      </div>

      <div
        v-if="false"
        class="application-officeless-box">
        <label class="label-report">Jumlah Pegawai Berdasarkan Status</label>
        <j-bar-chart-js
          v-if="showReportTotalPegawaiByStatus"
          :datacollection="datacollectionByStatus"
          :options="optionsByStatus" />
      </div>
      <div
        v-if="false"
        class="application-officeless-box">
        <label class="label-report">Jumlah Pegawai Berdasarkan Pendidikan</label>
        <j-pie-chart-js
          v-if="showReportTotalPegawaiByPendidikan"
          :datacollection="datacollectionByPendidikan"
          :options="optionsByPendidikan" />
      </div>
      <div
        v-if="false"
        class="application-officeless-box">
        <label class="label-report">Total Siswa</label>
        <j-bar-chart-js
          v-if="showReportTotalSiswa"
          :datacollection="datacollectionSiswa"
          :options="optionsSiswa" />
      </div>
      <div
        v-if="false"
        class="application-officeless-box">
        <label class="label-report">Total Lulusan</label>
        <j-bar-chart-js
          v-if="showReportTotalLulusan"
          :datacollection="datacollectionLulusan"
          :options="optionsLulusan" />
      </div>
    </div>

    <b-modal
      ref="modalPengumuman"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div class="title-bold">PENGUMUMAN</div>
      <div class="label-date-pengumuman">
        <img
          src="../../assets/menu-home/calendar.png"
          class="m__r--10">
        {{ convertDate(pengumuman_selected.start_date) }} - {{ convertDate(pengumuman_selected.end_date) }}
      </div>

      <div class="container-pengumuman m__b--25">
        <div class="text-pengumuman-modal">{{ pengumuman_selected.subject }}</div>
      </div>
      <div v-html="decodeHtmlEntities(pengumuman_selected.description)"/>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue"
          @click="$refs.modalPengumuman.hide()">
          Close
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalRiwayat"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div class="title-bold">RIWAYAT GAJI BERKALA</div>

      <div
        v-show="showFormRiwayat"
        class="form-riwayat">
        <b-row>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.pangkat_golongan.$error}">
              <label> Pangkat Golongan </label>
              <j-input
                v-model="$v.data_master.pangkat_golongan.$model"
                placeholder="Pangkat Golongan"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.no_sk.$error}">
              <label> Nomor SK </label>
              <j-input
                v-model="$v.data_master.no_sk.$model"
                placeholder="Nomor SK"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.tanggal_sk.$error}">
              <label> Tanggal SK Berkala </label>
              <j-datepicker
                v-model="$v.data_master.tanggal_sk.$model"
                placeholder="Tgl SK Berkala"
                format="MMM dd, yyyy"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.tmt_kgb.$error}">
              <label> TMT SK Berkala </label>
              <j-datepicker
                v-model="$v.data_master.tmt_kgb.$model"
                placeholder="TMT SK Berkala"
                format="MMM dd, yyyy"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.masa_kerja_tahun.$error}">
              <label> Masa Kerja (Tahun) </label>
              <j-input
                v-model="$v.data_master.masa_kerja_tahun.$model"
                type="number"
                placeholder="Fakultas"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.masa_kerja_bulan.$error}">
              <label> Masa Kerja (Bulan) </label>
              <j-input
                v-model="$v.data_master.masa_kerja_bulan.$model"
                type="number"
                placeholder="Masa Kerja (Bulan)"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :class="{'error-input' : $v.data_master.gaji_pokok.$error}">
              <label> Gaji Pokok </label>
              <j-currency
                v-model="$v.data_master.gaji_pokok.$model"
                :options="exampleOptionCurrency"
                :input_mode="true"
                placeholder="Gaji Pokok"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <div class="float-to-right m__t--30">
              <b-button
                v-if="data_master.id"
                class="btn red m__r--5"
                @click="deleteDataRiwayat">
                Delete
              </b-button>
              <b-button
                class="btn gray"
                @click="closeDataRiwayat">
                Cancel
              </b-button>
              <b-button
                class="btn blue m__l--5"
                @click="saveDataRiwayat">
                {{ data_master.id ? 'Update' : 'Save' }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <v-server-table
        v-show="load_first"
        ref="tableServer"
        :columns="columns"
        :options="options"
        class="jTable"
        @loading="loading"
        @loaded="loaded"
        @row-click="openEditRiwayat">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="addDataRiwayat">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
          </b-form>
        </div>

        <div
          slot="gaji_pokok"
          slot-scope="props">
          <j-currency
            :value="Number(props.row.gaji_pokok)"
            :options="exampleOptionCurrency"/>
        </div>
      </v-server-table>
      <jLoadingTable v-if="!load_first"/>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue"
          @click="$refs.modalRiwayat.hide()">
          Close
        </b-button>
      </div>
    </b-modal>

    <div class="copyright-section">
      Copyright © 2021 NextDev
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-console */
import he from 'he';
import jwtDecode from 'jwt-decode';
import { mapMutations, mapActions, mapState } from 'vuex';

import { required } from 'vuelidate/lib/validators';
import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  data() {
    return {
      name: localStorage.getItem('full_name'),
      position: localStorage.getItem('username'),
      img: localStorage.getItem('photo'),
      nip: localStorage.getItem('nip'),
      pegawai_id: localStorage.getItem('pegawai_id'),
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),

      data_notif: null,
      data_pengumuman: [],
      pengumuman_selected: {
        start_date: '0000-00-00 00:00:00',
        end_date: '0000-00-00 00:00:00',
        subject: '',
        description: '',
      },

      // Data Riwayat
      data_master: {
        id_pegawai: localStorage.getItem('pegawai_id'),
        pangkat_golongan: '',
        no_sk: '',
        tanggal_sk: null,
        tmt_kgb: null,
        masa_kerja_tahun: null,
        masa_kerja_bulan: null,
        gaji_pokok: null,
      },
      exampleOptionCurrency: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        currencySymbol: 'Rp',
        currencySymbolPlacement: 'p',
        roundingMethod: 'U',
        minimumValue: '0',
        maximumValue: '99999999999999',
      },
      showFormRiwayat: false,
      load_first: false,
      data_table: [],
      columns: ['pangkat_golongan', 'no_sk', 'tanggal_sk', 'tmt_kgb', 'masa_kerja_tahun', 'masa_kerja_bulan', 'gaji_pokok'],
      options: {
        headings: {
          pangkat_golongan: 'PANGKAT GOLONGAN',
          no_sk: 'NOMOR SK',
          tanggal_sk: 'TANGGAL SK BERKALA',
          tmt_kgb: 'TMT SK BERKALA',
          masa_kerja_tahun: 'MASA KERJA (TAHUN)',
          masa_kerja_bulan: 'MASA KERJA (BULAN)',
          gaji_pokok: 'GAJI POKOK',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['pangkat_golongan', 'no_sk', 'tanggal_sk', 'tmt_kgb', 'masa_kerja_tahun', 'masa_kerja_bulan', 'gaji_pokok'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListGajiBerkala(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      // Report
      showReportTotalPegawaiByStatus: false,
      datacollectionByStatus: {
        labels: [],
        datasets: [],
      },
      optionsByStatus: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },

      showReportTotalPegawaiByPendidikan: false,
      datacollectionByPendidikan: {
        labels: [],
        datasets: [],
      },
      optionsByPendidikan: {
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },

      showReportTotalSiswa: false,
      datacollectionSiswa: {
        labels: [],
        datasets: [],
      },
      optionsSiswa: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },

      showReportTotalLulusan: false,
      datacollectionLulusan: {
        labels: [],
        datasets: [],
      },
      optionsLulusan: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },
    };
  },
  computed: {
    ...mapState('jStoreLogin', ['profile_data']),

    isKurikulum() {
      const roles = JSON.parse(localStorage.getItem('roles'));
      const haveAccess = ['admin', 'kepala_sekolah', 'kepegawaian', 'kurikulum', 'wali_kelas', 'kesiswaan', 'guru', 'kajur', 'surat_menyurat'];
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },

    isKesiswaan() {
      const roles = JSON.parse(localStorage.getItem('roles'));
      const haveAccess = ['admin', 'kepala_sekolah', 'kurikulum', 'wali_kelas', 'kesiswaan', 'guru', 'tu', 'sapras', 'hubin', 'tefa', 'kajur', 'siswa'];
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },

    isBK() {
      const roles = JSON.parse(localStorage.getItem('roles'));
      const haveAccess = ['admin', 'kepala_sekolah', 'wali_kelas', 'tu', 'hubin', 'wali_kelas', 'kajur', 'penelusuran_alumni', 'bk'];
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },

    isHubin() {
      const roles = JSON.parse(localStorage.getItem('roles'));
      const haveAccess = ['admin', 'kepala_sekolah', 'kurikulum', 'kesiswaan', 'sapras', 'hubin', 'wali_kelas', 'kajur', 'buku_tamu'];
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },

    isKepsek() {
      const roles = JSON.parse(localStorage.getItem('roles'));
      const haveAccess = ['kepala_sekolah'];
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },
  },
  watch: {
  },
  created() {
    this.listPengumuman();
    this.listNotif();

    if (this.isKepsek) {
      // this.totalPegawaiByStatus();
      // this.totalPegawaiByPendidikan();
      // this.totalSiswa();
      // this.totalLulusan();
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createGajiBerkala', 'updateGajiBerkala', 'deleteGajiBerkala', 'checkNotification']),
    ...mapActions('jStoreHubin', ['getListPengumuman']),
    ...mapMutations('jStoreLogin', ['setDataSidebar']),

    async totalPegawaiByStatus() {
      const getList = await jApiKurikulum.getTotalPegawaiByStatus();
      const values = Object.values(getList.data.data);
      this.datacollectionByStatus.labels = Object.keys(getList.data.data).map(el => el.replace('_', ' ').toUpperCase());
      this.datacollectionByStatus.datasets = [
        {
          label: 'Laki-laki',
          backgroundColor: '#1392ff',
          data: values.map(el => el.laki_laki),
        },
        {
          label: 'Perempuan',
          backgroundColor: '#f87979',
          data: values.map(el => el.perempuan),
        },
      ];
      this.showReportTotalPegawaiByStatus = true;
    },

    async totalPegawaiByPendidikan() {
      const getList = await jApiKurikulum.getTotalPegawaiByPendidikan();
      const values = Object.values(getList.data.data);
      this.datacollectionByPendidikan.labels = Object.keys(getList.data.data);
      this.datacollectionByPendidikan.datasets = [
        {
          label: 'Jumlah Pegawai Berdasarkan Pendidikan',
          data: values,
          backgroundColor: [
            'rgb(255, 99, 132)',
            'rgb(67, 252, 243)',
            'rgb(255, 205, 86)',
            'rgb(75, 219, 58)',
            'rgb(241, 67, 252)',
            'rgb(54, 162, 235)',
            'rgb(0, 231, 203)',
          ],
          hoverOffset: 7,
        },
      ];
      this.showReportTotalPegawaiByPendidikan = true;
    },

    async totalSiswa() {
      const getList = await jApiKurikulum.getTotalSiswa();
      const values = Object.values(getList.data.data);
      this.datacollectionSiswa.labels = Object.keys(getList.data.data).map(el => el.replace('_', ' ').toUpperCase());
      this.datacollectionSiswa.datasets = [
        {
          label: 'Jumlah',
          backgroundColor: '#1392ff',
          data: values,
        },
      ];
      this.showReportTotalSiswa = true;
    },

    async totalLulusan() {
      const getList = await jApiKurikulum.getTotalLulusan();
      const values = Object.values(getList.data.data);
      this.datacollectionLulusan.labels = Object.keys(getList.data.data);
      this.datacollectionLulusan.datasets = [
        {
          label: 'Bekerja',
          backgroundColor: '#1392ff',
          data: values.map(el => el.bekerja),
        },
        {
          label: 'Belum Ketahui',
          backgroundColor: '#f87979',
          data: values.map(el => el.belum_ketahui),
        },
        {
          label: 'Kuliah',
          backgroundColor: '#06CD00',
          data: values.map(el => el.kuliah),
        },
        {
          label: 'Wirausaha',
          backgroundColor: '#CD00CA',
          data: values.map(el => el.wirausaha),
        },
      ];
      this.showReportTotalLulusan = true;
    },

    loading(val) {
      const a = val;
      a.id_pegawai = this.pegawai_id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeDataRiwayat() {
      this.showFormRiwayat = false;
      this.data_master = {
        id_pegawai: localStorage.getItem('pegawai_id'),
        pangkat_golongan: '',
        no_sk: '',
        tanggal_sk: null,
        tmt_kgb: null,
        masa_kerja_tahun: null,
        masa_kerja_bulan: null,
        gaji_pokok: null,
      };
    },

    saveDataRiwayat() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        params.tanggal_sk = params.tanggal_sk ? this.$moment(params.tanggal_sk).format('YYYY-MM-DD') : '';
        params.tmt_kgb = params.tmt_kgb ? this.$moment(params.tmt_kgb).format('YYYY-MM-DD') : '';
        const action = this.data_master.id ? 'updateGajiBerkala' : 'createGajiBerkala';
        this[action](params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeDataRiwayat();
            }, 1500);
          }
        });
      }
    },

    deleteDataRiwayat() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteGajiBerkala(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeDataRiwayat();
              }, 1500);
            }
          });
        }
      });
    },

    addDataRiwayat() {
      this.showFormRiwayat = true;
      this.data_master = {
        id_pegawai: localStorage.getItem('pegawai_id'),
        pangkat_golongan: '',
        no_sk: '',
        tanggal_sk: null,
        tmt_kgb: null,
        masa_kerja_tahun: null,
        masa_kerja_bulan: null,
        gaji_pokok: null,
      };
    },

    openEditRiwayat(param) {
      this.showFormRiwayat = true;
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        pangkat_golongan: param.row.pangkat_golongan,
        no_sk: param.row.no_sk,
        tanggal_sk: param.row.tanggal_sk,
        tmt_kgb: param.row.tmt_kgb,
        masa_kerja_tahun: Number(param.row.masa_kerja_tahun),
        masa_kerja_bulan: Number(param.row.masa_kerja_bulan),
        gaji_pokok: Number(param.row.gaji_pokok),
      };
    },

    chooseMenu(val) {
      if (val === 'kurikulum') {
        if (this.cekAccess(['admin', 'kepala_sekolah', 'kepegawaian'])) {
          this.$router.push('/kepegawaian');
        } else if (this.cekAccess(['admin', 'kepala_sekolah', 'kesiswaan', 'guru', 'wali_kelas'])) {
          this.$router.push('/admin-pembelajaran/dokumen-saya');
        } else if (this.cekAccess(['admin', 'kepala_sekolah', 'guru', 'surat_menyurat'])) {
          this.$router.push('/admin-surat/surat-saya');
        } else if (this.cekAccess(['admin', 'kepala_sekolah', 'kesiswaan', 'kurikulum', 'wali_kelas', 'kajur'])) {
          this.$router.push('/laporan-walikelas/laporan-saya');
        }
      } else if (val === 'kesiswaan') {
        this.$router.push('/data-siswa');
      } else if (val === 'bk') {
        if (this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan', 'bk'])) {
          this.$router.push('/konseling');
        } else if (this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan', 'hubin', 'kajur', 'penelusuran_alumni', 'bk'])) {
          this.$router.push('/penelurusan-lulusan');
        } else if (this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan', 'tu', 'bk'])) {
          this.$router.push('/penelurusan-calon-penerima-bantuan');
        }
      } else if (val === 'hubin') {
        if (this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kurikulum', 'sapras', 'hubin', 'kajur'])) {
          this.$router.push('/mitra');
        } else if (this.cekAccess(['admin', 'kepala_sekolah', 'wali_kelas', 'kesiswaan', 'kurikulum', 'sapras', 'hubin', 'kajur'])) {
          this.$router.push('/pengumuman');
        } else if (this.cekAccess(['admin', 'kepala_sekolah', 'kesiswaan', 'kurikulum', 'sapras', 'hubin', 'kajur', 'buku_tamu'])) {
          this.$router.push('/buku-tamu');
        }
      }

      const window = JSON.parse(localStorage.getItem('window'));
      if (window.width > 1170) {
        this.setDataSidebar(val);
      }
      localStorage.setItem('sidebar', val);
    },

    directToSino() {
      window.open(`${process.env.GATE_URL}user/login-sino/${(JSON.parse(localStorage.getItem('Token'))).value}`, '_blank');
    },

    cekAccess(haveAccess) {
      const roles = JSON.parse(localStorage.getItem('roles'));
      return roles.filter(f => haveAccess.includes(f.name)).length > 0;
    },

    listPengumuman() {
      const date = this.$moment(new Date()).format('YYYY-MM-DD');
      const params = {
        start_date: `${date} 00:00:00`,
        end_date: `${date} 23:59:00`,
        page: 1,
        limit: 1000,
      };
      this.getListPengumuman(params).then((res) => {
        this.data_pengumuman = res.data.data;
      });
    },

    listNotif() {
      this.checkNotification().then((res) => {
        this.data_notif = res.data.data;
      });
    },

    openModalPengumuman(data) {
      this.pengumuman_selected = data;
      this.$refs.modalPengumuman.show();
    },

    decodeHtmlEntities(str) {
      return he.decode(str);
    },

    convertDate(serverDate) {
      const dt = new Date(Date.parse(serverDate)).getTime();
      return this.$moment(new Date(dt)).format('MMMM DD, YYYY');
    },
  },
  validations() {
    return {
      data_master: {
        pangkat_golongan: { required },
        no_sk: { required },
        tanggal_sk: { required },
        tmt_kgb: { required },
        masa_kerja_tahun: { required },
        masa_kerja_bulan: { required },
        gaji_pokok: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/home/jHome.vue